import React, { useState, useEffect } from "react";
import { Modal, ModalBody } from "@windmill/react-ui";
import ClientFeedbackServices from "services/ClientFeedbackServices";
import * as XLSX from "xlsx";
import CommonCloseBtn from "components/CloseButton/CommonCloseButton";

const ClientEscalationModal = ({
  isOpen,
  onClose,
  data,
  title = "Escalation",
  hideEdit,
  hideAdd,
  hideView,
  hideExport,
}) => {
  const [newMessage, setNewMessage] = useState("");
  const [feedbackHistory, setFeedbackHistory] = useState([]);
  const [error, setError] = useState("");

  const adminInfo = JSON.parse(localStorage.getItem("adminInfo"));
  const employeeName = adminInfo?.firstname || "Unknown Employee";
  const employeeId = adminInfo?.id;

  useEffect(() => {
    if (isOpen && data?.client_id) {
      fetchEscalationHistory();
    }
  }, [isOpen]);

  const fetchEscalationHistory = async () => {
    try {
      const res = await ClientFeedbackServices.getClientEscalation(
        data.client_id,
      );
      // console.log("client escalate", res);

      setFeedbackHistory(res.escalation || []);
    } catch (err) {
      console.error("Fetch escalation error:", err);
    }
  };

  const handleSave = async () => {
    if (!newMessage.trim()) {
      setError("Message cannot be empty");
      return;
    }

    const updated = [...feedbackHistory];
    const lastSession = updated[updated.length - 1];

    const newMsg = {
      employee_name: employeeName,
      employee_id: employeeId,
      message: newMessage,
      updated_at: new Date().toLocaleString(),
    };

    lastSession.messages.push(newMsg);

    const payload = {
      employee_id: employeeId,
      escalation_history: [
        {
          status: lastSession.status,
          messages: [newMsg],
          updated_by: employeeId,
          sessionStartedAt: new Date().toLocaleString(),
        },
      ],
    };

    await ClientFeedbackServices.updateClientEscalation(
      data.client_id,
      payload,
    );

    setFeedbackHistory(updated);

    setNewMessage("");
    setError("");
  };

  const handleSorted = async () => {
    const updated = [...feedbackHistory];
    const lastSession = updated[updated.length - 1];

    lastSession.status = "sorted";

    const finalMsg = {
      employee_name: employeeName,
      employee_id: employeeId,
      message: "Escalate Over",
      updated_at: new Date().toLocaleString(),
    };

    lastSession.messages.push(finalMsg);

    const payload = {
      employee_id: employeeId,
      escalation_history: [
        {
          status: "sorted",
          messages: [finalMsg],
          updated_by: employeeId,
          sessionStartedAt: new Date().toLocaleString(),
        },
      ],
    };

    await ClientFeedbackServices.updateClientEscalation(
      data.client_id,
      payload,
    );

    setFeedbackHistory(updated);
    onClose();
  };

  // Start a new escalation session
  const handleStartEscalation = () => {
    const newSession = {
      sessionStartedAt: new Date().toLocaleString(),
      status: "ongoing",
      messages: [],
    };
    //  console.log("starting escalate", newSession);

    const updated = [...feedbackHistory, newSession];

    setFeedbackHistory(updated);
  };

  const last = feedbackHistory[feedbackHistory.length - 1];

  const exportEscalationToExcel = (session, index) => {
    const rows = session.messages.map((msg, i) => ({
      "SI.No": i + 1,
      Employee: msg.employee_name,
      // Message: msg.message,
      Message: `${msg.message}  (${msg.updated_at})`,
    }));

    const worksheet = XLSX.utils.json_to_sheet(rows);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      `Escalation_${index + 1}`,
    );

    XLSX.writeFile(workbook, `Escalation_${index + 1}.xlsx`);
  };

  return (
    <>
      {hideView && (
        <Modal
          isOpen={isOpen}
          onClose={() => {
            onClose();
            setError("");
            setNewMessage("");
          }}
          className="relative bg-white dark:bg-gray-700 pb-0 p-4 w-1/3 rounded-lg"
        >
          <div className="flex justify-between">
            <div>
              <span className="flex text-xl mb-3 text-green-500">{title}</span>
            </div>

            <CommonCloseBtn onClose={onClose} />
          </div>

          {/* History */}
          {feedbackHistory.length > 0 && (
            <>
              <div
                className="border border-gray-300 rounded-md p-3 bg-gray-50 
      max-h-64 overflow-y-auto space-y-3 shadow-inner"
              >
                {/* {feedbackHistory.map((session, i) => (
        <div
          key={i}
          className="border rounded-md p-2 bg-white shadow-sm"
        >
          
          <div className="flex justify-between items-center mb-2">
      <p className="text-xs text-gray-600">
        <b>Escalate {i + 1}</b> —{" "}
        {session?.status === "sorted" ? "Completed" : "Ongoing"}
      </p>

    {hideExport && (
      <button
        className="text-xs bg-green-200 px-2 py-1 rounded hover:bg-green-300"
        onClick={() => exportEscalationToExcel(session, i)}
      >
        Export
      </button>
      )}
    </div>

          {session?.messages?.map((msg, index) => (
            <p key={index} className="text-sm text-black mb-1">
              <b>{msg?.employee_name}</b>: {msg?.message}
            </p>
          ))}
        </div>
      ))} */}
                {feedbackHistory.map((session, i) => {
                  const sessionStart =
                    session.sessionStartedAt || session.escalate_at || "N/A";

                  return (
                    <div
                      key={i}
                      className="border rounded-md p-2 bg-white shadow-sm"
                    >
                      {/* Session Header */}
                      <div className="flex justify-between items-center mb-2">
                        <p className="text-xs text-gray-700">
                          <b>
                            Escalate {i + 1} —{" "}
                            {session?.status === "sorted"
                              ? "Sorted"
                              : "Ongoing"}
                          </b>
                          <span className="text-[10px] text-gray-500 ml-1">
                            ({sessionStart})
                          </span>
                        </p>

                        {hideExport && (
                          <button
                            className="text-xs bg-green-200 px-2 py-1 rounded hover:bg-green-300"
                            onClick={() => exportEscalationToExcel(session, i)}
                          >
                            Export
                          </button>
                        )}
                      </div>

                      {/* Messages */}
                      {session?.messages?.map((msg, index) => (
                        <div key={index} className="mb-1">
                          <p className="text-xs text-gray-700">
                            <b>{msg?.employee_name}</b>: {msg?.message}
                            <span className="text-[10px] text-gray-500 ml-1">
                              ({msg.updated_at})
                            </span>
                          </p>
                        </div>
                      ))}
                    </div>
                  );
                })}
              </div>
            </>
          )}

          {hideEdit && (
            <ModalBody className="text-center pt-3 pb-4">
              {/* If last session is ongoing → show message box */}
              {last && last.status === "ongoing" ? (
                <>
                  <textarea
                    placeholder="Enter message"
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    className="w-full h-28 border border-gray-300 rounded-md p-2"
                  />

                  {error && (
                    <p className="text-red-500 text-sm mt-2">{error}</p>
                  )}

                  <div className="flex justify-between mt-4">
                    <button
                      onClick={handleSave}
                      className="px-4 py-2 bg-green-500 text-white rounded-md"
                    >
                      Save Message
                    </button>

                    <button
                      onClick={handleSorted}
                      className="px-4 py-2 bg-orange-500 text-white rounded-md"
                    >
                      Sorted
                    </button>
                  </div>
                </>
              ) : (
                // otherwise start new session
                <button
                  onClick={handleStartEscalation}
                  className="px-4 py-2 bg-blue-500 text-white rounded-md mb-4"
                >
                  Start Escalation
                </button>
              )}
            </ModalBody>
          )}
        </Modal>
      )}
    </>
  );
};

export default ClientEscalationModal;
